import { LegalLayout } from "@/components/legal/LegalLayout";

const AydinlatmaMetniPage = () => (
  <LegalLayout
    title="Kişisel Verilerin Korunması Aydınlatma Metni"
    description="İns Organizasyon Aydınlatma Metni, kişisel verilerin hangi amaçlarla işlendiğini ve haklarınızı açıklar."
    path="/aydinlatma-metni"
  >
    <p>
      6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) ve ilgili mevzuat kapsamında veri sorumlusu
      İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti. (“İns Organizasyon”) olarak kişisel verilerinizi aşağıda
      belirtilen çerçevede işlemekteyiz.
    </p>

    <h2>1. Veri Sorumlusunun Kimliği</h2>
    <p>
      Veri sorumlusu: İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti.<br />
      Adres: Çamlıca Mah. 168. Cad. No: 3 Yenimahalle / Ankara<br />
      Telefon: +90 541 587 88 22<br />
      E-posta: info@insorganizasyon.org
    </p>

    <h2>2. Kişisel Verilerin İşlenme Amaçları</h2>
    <ul>
      <li>STK iş birlikleri ve saha operasyonlarının planlanması ve yürütülmesi</li>
      <li>Bağışçı, partner ve gönüllü ilişkilerinin yönetilmesi</li>
      <li>Yasal yükümlülüklerin yerine getirilmesi ve denetim süreçlerinin yürütülmesi</li>
      <li>İletişim, bilgilendirme ve raporlama faaliyetlerinin gerçekleştirilmesi</li>
      <li>Bilgi güvenliği süreçlerinin yürütülmesi</li>
    </ul>

    <h2>3. İşlenen Kişisel Veri Kategorileri</h2>
    <ul>
      <li>Kimlik bilgileri (ad, soyad, TCKN, pasaport numarası)</li>
      <li>İletişim bilgileri (telefon, e-posta, adres)</li>
      <li>Finansal bilgiler (banka hesap bilgileri, bağış kayıtları)</li>
      <li>İşlem güvenliği bilgileri (log kayıtları, IP bilgileri)</li>
      <li>Görsel ve işitsel kayıtlar (proje raporlamasında kullanılan fotoğraf ve videolar)</li>
    </ul>

    <h2>4. Kişisel Verilerin Aktarımı</h2>
    <p>
      Kişisel verileriniz, KVKK’nın 8. ve 9. maddeleri kapsamında yurt içi ve yurt dışındaki iş ortaklarımıza, resmi
      kurumlara ve hizmet sağlayıcılarımıza aktarılabilmektedir. Aktarım yapılırken gerekli güvenlik tedbirleri alınmaktadır.
    </p>

    <h2>5. Veri Toplama Yöntemi ve Hukuki Sebep</h2>
    <p>
      Kişisel verileriniz; web sitemizde yer alan formlar, sözleşmeler, dijital iletişim kanalları, saha raporları ve fiziki
      formlar aracılığıyla otomatik veya otomatik olmayan yollarla toplanmaktadır. Verileriniz KVKK’nın 5. ve 6. maddelerinde
      belirtilen açık rıza, kanunlarda öngörülme, sözleşmenin kurulması veya ifası gibi hukuki sebeplere dayanarak işlenir.
    </p>

    <h2>6. KVKK’nın 11. Maddesi Kapsamındaki Haklarınız</h2>
    <p>İlgili kişi olarak aşağıdaki haklara sahipsiniz:</p>
    <ul>
      <li>Kişisel verilerin işlenip işlenmediğini öğrenme</li>
      <li>İşlenmişse bilgi talep etme</li>
      <li>İşleme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme</li>
      <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
      <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
      <li>KVKK’nın 7. maddesi kapsamında silinmesini veya yok edilmesini isteme</li>
      <li>Aktarılan üçüncü kişilere bildirilmesini isteme</li>
      <li>Oluşan zararın giderilmesini talep etme</li>
    </ul>

    <h2>7. Başvuru Yöntemi</h2>
    <p>
      Haklarınıza ilişkin taleplerinizi <a href="/kvkk-basvuru-formu">KVKK Başvuru Formu</a> aracılığıyla yazılı olarak veya
      info@insorganizasyon.org adresine iletebilirsiniz. Başvurular en geç 30 gün içinde cevaplandırılacaktır.
    </p>

    <p>
      İşbu aydınlatma metni güncellenebilir olup, değişiklik olması halinde web sitemiz üzerinden paylaşılacaktır.
    </p>
  </LegalLayout>
);

export default AydinlatmaMetniPage;
